import type { ComponentProps } from 'react';
import type CardLocation from '@alltrails/amplitude/enums/CardLocation';
import type MapLocation from '@alltrails/amplitude/enums/MapLocation';
import type TrailCardLocation from '@alltrails/amplitude/enums/TrailCardLocation';
import { PageStrings } from '@alltrails/core/constants/pageStringHelpers';
import TrailResults from '@alltrails/maps/components/TrailResults/TrailResults';
import { useExploreTrailUrl, useMapTrailNavigate } from '@/hooks/useTrailNavigate';
import { useLogExploreCardViewed } from '@/utils/analyticsHelpers';
import { useAppSelector } from '@/utils/redux';

type Props = {
  handleFavoriteClick?: (trailId: number) => void;
  cardLocation?: TrailCardLocation;
  detailedCardLocation?: CardLocation;
  mapLocation?: MapLocation | string;
} & Pick<ComponentProps<typeof TrailResults>, 'hasCommunityInsights'>;

const TrailResultsMapComponents = ({
  handleFavoriteClick,
  cardLocation = 'explore map view',
  detailedCardLocation = 'explore tab map view',
  hasCommunityInsights,
  mapLocation = PageStrings.EXPLORE_ALL_PAGE
}: Props) => {
  const logExploreCardViewed = useLogExploreCardViewed('trail');
  const onTrailNavigate = useMapTrailNavigate();
  const getExploreTrailUrl = useExploreTrailUrl();
  const activityType = useAppSelector(state => state.exploreService.filters?.activity?.[0]);

  return (
    <TrailResults
      activityType={activityType}
      cardLocation={cardLocation}
      detailedCardLocation={detailedCardLocation}
      hasCommunityInsights={hasCommunityInsights}
      mapLocation={mapLocation}
      onSingleTrailPinClick={onTrailNavigate}
      onTrailCardViewed={logExploreCardViewed}
      onTrailNavigate={onTrailNavigate}
      getTrailCardUrl={getExploreTrailUrl}
      handleFavoriteClick={handleFavoriteClick}
    />
  );
};

export default TrailResultsMapComponents;
